
import {useStore} from "@/store";
import iconOk from '@/assets/toc/ok.png';
import {useRouter, useRoute} from "vue-router";
    // , computed, ComputedRef, watch, reactive
import {defineComponent, reactive, ComputedRef, computed, toRefs, watch} from "vue";
import  reportMsgUt from "@/util/reportMsg";

interface State {
    currentIndex: number;
    tocOnlyShowFlaw: boolean;
    photoList: object[];
    templateCode: string;
    reportMsg: object;
    accidentFlag: number;// 0 非事故车 1 非重大事故 2 重大事故车
    isFire: number; // 0不是火烧车 1是火烧车
    isWater: number; // 0不是泡水车 1是泡水车
}
export default defineComponent({
    name: 'checkContent',
    props: {
        carContentRenderData: {
            type: Array,
            default: () => {
                return []
            }
        },
        carContentParentCode: {
            type: String,
            default: ''
        },
        carContentParentIndex: {
            type: Number,
            default: -1
        }
    },
    setup(props) {
        let state: State = reactive({
            currentIndex: 0,
            tocOnlyShowFlaw: false,
            templateCode: '',
            photoList: [],
            pageScrollTop: 0,
            reportMsg: {},
            accidentFlag: 0,
            isFire: 0,
            isWater: 0,
        })
        state.reportMsg = reportMsgUt;
        const router = useRouter();
        let store = useStore();
        let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
        watch(tocOnlyShowFlawS, (data: any) => {
            // console.log('checkPosition:tocOnlyShowFlaw:', data);
            state.tocOnlyShowFlaw = data;
            if (data) {
                let index=0;
                for (let i=0;i<props.carContentRenderData.length;i++) {
                    let item: any = props.carContentRenderData[i];
                    if (item.defectItemCount >0) {
                        index = i;
                        break;
                    }
                }
                state.currentIndex = index;
            }
        }, {immediate: true})
        let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
        watch(dataInfo, (data: any) => {
            const {photoList,accidentFlag,isFire,isWater} = data
            state.photoList = photoList;
            state.accidentFlag = accidentFlag;
            state.isFire = isFire;
            state.isWater = isWater;
        },{immediate: true})
        function changeContentShowItem(index) {
            state.currentIndex = index;
        }
        function getCongValueLevelStyle(level: string) {
            let valueClass = {};
            if (level === 'L002') {//严重
                valueClass = {"congValue_orangeColor": true};
            }else if (level === 'L001') {//一般
                valueClass = {"congValue_grayColor": true};
            } else {
                valueClass = {"congValue_orangeColor": true};
            }
            return valueClass;
        }
        //redSign 0：正常  1：异常不标红 2：异常标红 针对火烧、事故、泡水三个模块
        function getCongValueClass(level: string,redSign: number,parentCode: string) {
            if (state.reportMsg['RpCK']()) {//车况报告及其车况报告加购系列走原来的严重一般逻辑
                let valueClass = getCongValueLevelStyle(level);
                return valueClass;
            } else {
                if (parentCode === 'Accident' || parentCode === 'Fire'|| parentCode === 'SoakWater') {//事故、火烧、泡水模块
                    if (redSign === undefined) {
                        let valueClass = getCongValueLevelStyle(level);
                        return valueClass;
                    } else {
                        if ((parentCode === 'Accident'&& state.accidentFlag  === 2) || (parentCode === 'Fire'&& state.isFire  === 1) || (parentCode === 'SoakWater'&& state.isWater  === 1)) {
                            let valueClass = {};
                            if (redSign === 2) {
                                valueClass = {"congValue_orangeColor": true};
                                return valueClass;
                            } else {
                                valueClass = {"congValue_grayColor": true};
                                return valueClass;
                            }
                        } else {
                            let valueClass = getCongValueLevelStyle(level);
                            return valueClass;
                        }
                    }
                } else {
                    let valueClass = getCongValueLevelStyle(level);
                    return valueClass;
                }
            }
        }
        //redSign 0：正常  1：异常不标红 2：异常标红 针对火烧、事故、泡水三个模块
        function getCongValueDes(congValue: string,redSign: number,parentCode: string) {
            if (state.reportMsg['RpCK']()) {//车况报告及其车况报告加购系列走原来的严重一般逻辑
                return congValue;
            } else {
                if (parentCode === 'Accident' || parentCode === 'Fire'|| parentCode === 'SoakWater') {//事故、火烧、泡水模块
                    if (redSign === undefined) {//上线以前静态化的数据
                        return congValue;
                    } else {//有缺陷标识
                        if ((parentCode === 'Accident'&& state.accidentFlag > 0 ) || (parentCode === 'Fire'&& state.isFire  === 1) || (parentCode === 'SoakWater'&& state.isWater  === 1)) {
                            if (redSign === 2) {
                                if (parentCode === 'Accident') {
                                    return congValue + '(事故项)';
                                } else if (parentCode === 'Fire') {
                                     return congValue + '(火烧项)';
                                } else if (parentCode === 'SoakWater') {
                                     return congValue + '(泡水项)';
                                } else {
                                     return congValue;
                                }
                            } else {
                                return congValue;
                            }
                        } else {
                            return congValue;
                        }               
                    }
                } else {
                    return congValue;
                }
            }
        }
        return {
            state,
            router,
            store,
            changeContentShowItem,
            getCongValueClass,
            getCongValueDes,
        }
    },
    methods: {
        goToImgView(item, parentIndex, sonIndex) {
            // console.log('goToImgView'+JSON.stringify(item) + 'parentIndex' + parentIndex + 'sonIndex' + sonIndex);
            if (item.itemDesc === '无此部件') {
                return;
            }
            // let noImg = 0;
            // if (item.itemDesc === '受限不可检' || item.photoList.length === 0) {
            //     noImg = 1;
            // }
            let photo = item.photoList && item.photoList[0];
            let queryPar: any = {
                group: 'defect',
            }
            if (item.itemDesc === '受限不可检') {
                queryPar.noImg = 1;
            } else if (item.photoList.length === 0) {
                queryPar.noImg = 1;
                queryPar.currentIndex = `${this.carContentParentIndex},${parentIndex},${sonIndex}`;
            } else {
                queryPar.photoCode = (photo && photo.photoIdStr) || '';
            }
            this.store.dispatch('savePageScrollTop', window.scrollY);
            this.router.push({
                path:'/tocV3PhotoList',
                query: queryPar
            })
        },
    }
})
